<template>
  <div id="SendFileToAdmin" dir="rtl">
    <loading v-if="Loading"></loading>
    <net-pa-list-page-card
      title="ارسال فایل و مدارک"
      description="از طریق این فرم می‌توانید فایل‌های خواسته شده را برای مدیر سامانه ارسال نمایید"
      :show-back="true"
    >
      <div class="send-file-upload" id="SendFile">
        <input
          type="file"
          @change="changefile($event)"
          class="d-none"
          :key="RenderFile"
          id="Uploader"
          accept=".gif,.jpg,.jpeg,.png,.zip,.rar,.pdf"
        />
        <div v-if="!fileinfo.size && !fileinfo.name" class="send-file-upload__empty">
          <p class="send-file-upload__hint">لطفا فایل مورد نظر خود را بارگذاری نمایید</p>
          <button type="button" class="btn btn-success" @click="clickUploader">
            بارگذاری
          </button>
        </div>

        <div v-else class="send-file-upload__form">
          <div class="send-file-upload__meta">
            <span v-if="fileinfo.size">
              حجم فایل:
              <strong>{{ (fileinfo.size / 1000000).toFixed(2) }} مگابایت</strong>
            </span>
            <span v-if="fileinfo.name">
              مشخصات فایل:
              <strong>{{ fileinfo.name }}</strong>
            </span>
          </div>
          <div class="send-file-upload__title-field">
            <label class="send-file-upload__label" for="OnvanFile">عنوان فایل</label>
            <input
              id="OnvanFile"
              type="text"
              class="form-control required"
              v-model="OnvanFile"
              @input="CheckValue($event)"
            />
          </div>
          <div class="send-file-upload__actions">
            <button
              type="button"
              class="btn btn-success"
              @click="SendFileforAdmin"
            >
              <i class="fa fa-upload ml-1" aria-hidden="true"></i>
              ارسال فایل
            </button>
            <button type="button" class="btn btn-outline-danger" @click="Cancel">
              <i class="fa fa-times ml-1" aria-hidden="true"></i>
              انصراف
            </button>
          </div>
        </div>
      </div>

      <div class="send-file-list mt-3">
        <ListAzaFile
          :key="RenderFile"
          :ShowHeader="false"
          :IsAdmin="false"
          :wwwtblAzaId="AzaId"
        ></ListAzaFile>
      </div>
    </net-pa-list-page-card>
  </div>
</template>
<script>
import Loading from "../Tools/NetPa/Loading.vue";
import NetPaListPageCard from "../Tools/NetPa/NetPaListPageCard.vue";
import ListAzaFile from "./ListAzaFile.vue";

export default {
  components: { NetPaListPageCard, ListAzaFile, Loading },
  data() {
    return {
      fileinfo: {},
      RenderFile: 0,
      AzaId: this.$session.get("UserInfoNetPa").wwwtblAzaId,
      Loading: false,
      Render: 0,
      OnvanFile: null,
      NotSend: true,
    };
  },
  methods: {
    clickUploader() {
      document.getElementById("Uploader").click();
    },
    changefile(e) {
      const file = e.target.files[0];
      if (!file) return;

      const allowedExtensions = [
        "gif",
        "jpg",
        "jpeg",
        "png",
        "zip",
        "rar",
        "pdf",
      ];
      const fileExtension = file.name.split(".").pop().toLowerCase();
      if (!allowedExtensions.includes(fileExtension)) {
        this.$mySweetDefaultTost(
          "فرمت فایل مجاز نیست",
          `فرمت ${fileExtension} پشتیبانی نمی‌شود.`,
          "error",
          3000,
        );
        e.target.value = "";
        return;
      }
      if (document.getElementById("Uploader").files[0].size > 1024 * 1024 * 5) {
        this.$mySweetDefaultTost(
          "عملیات ناموفق",
          "  حجم فایل ارسالی بیشتر از 5 مگابایت است ",
          "error",
          3000,
        );
        this.fileinfo = {};
        this.RenderFile++;
        return;
      } else {
        this.fileinfo = document.getElementById("Uploader").files[0];
      }
    },
    SendFileforAdmin() {
      if (!this.$ValidForm("SendFile")) {
        return;
      }
      if (this.NotSend == true) {
        this.$mySweetDefaultTost(
          "ورودی نا معتبر",
          "وارد کردن عنوان فایل الزامی می باشد ",
          "error",
          1200,
        );
        return;
      }
      this.$SweetQustion(
        "اطمینان از ارسال فایل ",
        "از ارسال فایل خود اطمینان دارید؟ در صورت ارسال ، ویرایش فایل امکان پذیر نیست",
        "question",
        "تایید ",
        "انصراف",
        this.fileinfo,
        this.SendFile,
        this.isNotConfirmed,
      );
    },
    Cancel() {
      this.fileinfo = {};
      this.RenderFile++;
    },
    SendFile() {
      this.Loading = true;
      let DataAxiosUpload = {
        ArryfildValue: "",
        Method: "Post",
        Action: "EftetahHesab/SaveAttachmentToDb",
        Token: "",
      };
      var formdata = new FormData();
      formdata.append(
        "IdEftetah",
        this.$session.get("UserInfoNetPa").wwwtblAzaId,
      );
      formdata.append("Image", this.fileinfo);
      formdata.append("TableName", "FileToAdmin");
      formdata.append("wwwtblcomboidgrp328", null);
      formdata.append("FileTitle", this.OnvanFile);
      DataAxiosUpload.ArryfildValue = formdata;
      this.$PostFormData(DataAxiosUpload).then((data) => {
        this.Loading = false;
        if (data.status == "Ok") {
          this.$mySweetDefault(
            "ارسال موفق",
            "فایل شما با موفقیت برای مدیر سامانه ارسال گردید",
            "success",
            2000,
          );
        } else {
          this.$mySweetDefault(
            "ارسال ناموفق",
            "فایل شما ارسال نشد  لطفا دقایق دیگر تلاش کنید",
            "danger",
            2000,
          );
        }
        this.Cancel();
      });
    },
    isNotConfirmed() {},
    CheckValue(ev) {
      if (ev.target.value.trim().length == 0) {
        ev.target.classList.add("wronginput");
        ev.target.focus();
        this.NotSend = true;
        this.$mySweetDefaultTost(
          "ورودی نا معتبر",
          "فیلد مشخص شده الزامی می باشد ",
          "error",
          1200,
        );
      } else {
        this.NotSend = false;
        ev.target.classList.remove("wronginput");
      }
    },
  },
};
</script>
<style scoped>
.send-file-upload {
  padding: 1rem;
  border: 1px solid #e8ecf1;
  border-radius: 10px;
  background: #f8f9fb;
}

.send-file-upload__empty {
  text-align: center;
}

.send-file-upload__hint {
  margin: 0 0 0.75rem;
  color: #6c757d;
  font-size: 0.9rem;
}

.send-file-upload__form {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.send-file-upload__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem 1.25rem;
  font-size: 0.875rem;
  color: #495057;
}

.send-file-upload__title-field {
  max-width: 420px;
}

.send-file-upload__label {
  display: block;
  margin-bottom: 0.35rem;
  font-size: 0.875rem;
  color: #6c757d;
}

.send-file-upload__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}
</style>
